<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">3.1、创建表</h1>
					<h2 class="about-cs">3.1.1概念</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 数据库里创建表就好比菜老板准备了两个笔记本的这个过程。
					</div>
					<h2 class="about-cs">3.1.2建表语句</font>
					</h2>
					<div class="about-t">


						&nbsp; &nbsp;&nbsp; &nbsp; 先给出建表语句，将如下语句复制既可以立马创建商品信息表。<br />
						<!-- 在这里传入后台返回的文本数据和关键字就可以了 -->
						<!-- <change-key-word keyword="关键字" text="这一行有一个关键字"> </change-key-word><br /> -->


						<sql-show :value="sqlInfo"> </sql-show>
                        注：创建过该表请删除后再执行该语句，删除语句 drop table PRODUCT_T;

						<!-- <div v-if="ifLogin"> -->
						<!-- <div style="padding-left: 50px;">
							<img style="width: 40px;" :src="require('../../assets/image/jiantou.png')">
							<a @click="toRunSql">打开我的在线sql学习编辑器 </a></br>
						</div> -->
						<!--  </div> -->
						<change-key-word keyword="创建MySQL数据表需要以下信息：" text="创建MySQL数据表需要以下信息：表名、表字段名、定义每个表字段类型。">
						</change-key-word><br />
						<change-key-word keyword="表名：" text="表名：PRODUCT_T"> </change-key-word><br />
						解释：表的唯一标识，在故事中PRODUCT_T对应菜老板的商品信息笔记本<br />
						<change-key-word keyword="表字段名："
							text="表字段名：PRODUCT_NO, PRODUCT_NAME, PRODUCT_NUM, PRODUCT_PRICE，CREATE_TIME">
						</change-key-word><br />
						解释：上述字段分别对应商品编号、商品名称、进货数量、进货价格、记录创建时间<br />
						<change-key-word keyword="定义每个表字段："
							text="定义每个表字段：VARCHAR(100),VARCHAR(200),DATETIME,INT,DECIMAL(10,2)"> </change-key-word>
						<br />
						解释：<br />
						<change-key-word keyword="VARCHAR(100): "
							text="VARCHAR(100): PRODUCT_NO（商品编号）是由数字和字母组成的用VARCHAR标识字符串（100）表示字符串的长度。例如：abc字符串的长度是3。">
						</change-key-word><br />
						<change-key-word keyword="VARCHAR(200):"
							text="VARCHAR(200): PRODUCT_NAME（商品名称）同上，只是长度变为200，因为商品名称可能会比较长。"> </change-key-word><br />
						<change-key-word keyword="INT:" text="INT:PRODUCT_NUM（商品数量）这里数量只能是整数，不会出现小数或者英文字母之类的。注:INT也可以是0和负整数">
						</change-key-word><br />
						<change-key-word keyword="DECIMAL(10,2):"
							text="DECIMAL(10,2):PRODUCT_PRICE（商品价格）价格我们这里保留两位小数，总长度是10位（8位整数部分+2位小数部分）">
						</change-key-word><br />
						<change-key-word keyword="DATETIME:"
							text="DATETIME: CREATE_TIME (记录创建时间)记录的必须是一个时间格式例如：2022-10-13:17:37:20，不能是任意的数字和字符。">
						</change-key-word><br />
						注：PRIMARY KEY (PRODUCT_NO)后续3.5章节会详细描述，ENGINE=INNODB DEFAULT CHARSET=UTF8
						初学者不用管，记住这么写就行，今后也能满足90%以上的工作场景。
					</div>
					<h2 class="about-cs">3.1.3字段类型</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp;
						上面表的基本建表语句中对字段的定义我们使用了VARCHAR、DATETIME、INT、DECIMAL数据类型，实际上介绍的这四种数据类型在今后的工作中基本够用了，其他的需要用的时候再去查即可，mysql里一共有多少种数据类型呢？<br />
						&nbsp; &nbsp;&nbsp; &nbsp;参考如下网址：
						<a href="https://www.runoob.com/mysql/mysql-data-types.html"
							target="_blank">https://www.runoob.com/mysql/mysql-data-types.html</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ChangeKeyWord from '@/components/project/ChangeKeyWord.vue'

	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {
			ChangeKeyWord,
			SqlShow,
		},

		data() {
			return {
				userId: '',
				ifLogin: false,
				sqlInfo: 'CREATE TABLE PRODUCT_T ( \r\n' +
					'   PRODUCT_NO 		VARCHAR(100) ,\r\n' +
					'   PRODUCT_NAME 	VARCHAR(200) ,\r\n' +
					'   PRODUCT_NUM 		INT ,\r\n' +
					'   PRODUCT_PRICE 	DECIMAL(10,2) ,\r\n' +
					'   CREATE_TIME 		DATETIME ,\r\n' +
					'   PRIMARY KEY (PRODUCT_NO)\r\n' +
					')ENGINE=INNODB DEFAULT CHARSET=UTF8 ;',
			}
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			toRunSql() {
				if (this.ifLogin == true) {
					let routeUrl = this.$router.resolve({
						path: '/run',
					})
					window.open(routeUrl.href, '_blank')
				} else {
					this.$Message.warning('登录付费后才能使用该功能！');
				}
			}

		},

	}
</script>

<style lang="scss" scoped>
	//写上样式
	.keyWord {
		color: #0fbda0;
	}


	#vip {
		color: red;
	}

	.about-xs {
		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	.aw-register-box .mod-body .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
